import { createFileRoute } from '@tanstack/react-router';
import { Header } from '@/components/Header';
import { Notifications } from '@/pages/Notifications';

export const Route = createFileRoute('/_authenticated/notifications/')({
  component: NotificationsPage,
});

function NotificationsPage() {
  return (
    <>
      <Header enableBack fallbackTo="/" />
      <Notifications />
    </>
  );
}
